<template>
  <div>
    <!-- HEADER -->
    <vs-row>
      <vs-col vs-type="flex" vs-align="flex-start" vs-justify="flex-start" vs-w="8" class="px-2">
        <feather-icon
            class="inline-flex mr-4"
            icon="UserIcon" />
        <h3>
          {{item.email}}
        </h3>
      </vs-col>
    </vs-row>
    <!-- END: HEADER -->

    <vs-tabs>
      <vs-tab class="px-0" icon="face" @click="initPopup(item)" label="Sites"><sites :item="item" ref="sites" /></vs-tab>
    </vs-tabs>
  </div>
</template>
<script>
export default{
	data() {
		return {
			// activeTab: 'case',
		}
	},
  props: {
    item: {
      type: Object,
      required: true
    },
  },
	components: {
    Sites: () => import("./tabs/Sites.vue"),
  },
  methods: {
    initPopup(user) {
      this.$nextTick(() => {
        if(this.$refs.sites){this.$refs.sites.getRecords(user.email);}
      });
    },
  },
}
</script>
<style>
.tabNavs .con-vs-chip {
  cursor: pointer;
}
.vs-list--item .list-titles .vs-list--subtitle,
.vs-card--content {
  font-size: 0.95rem;
}
.con-vs-popup .vs-popup {
  width: 1200px;
  height: 100%;
}
.vs-tabs--btn {
  font-weight: bold;
}
</style>
